import React, {Component} from 'react';
import Contact from '../components/common/Contact';
import FooterDesktop from '../components/common/FooterDesktop';
import MainHeader from '../components/common/MainHeader';
import { Helmet } from 'react-helmet';
class ContactPage extends Component {
    handleClick = () => {
        const currentUrl = window.location.href;
        const pageTitle = document.title;
        const message = `Hi, Please send about the Tour Package details "${pageTitle}"`;
        // Push custom event to GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'whatsappSubmissionSuccess',
            formId: 'whatsappback' // Example form ID
        });
        const whatsappLink = `https://api.whatsapp.com/send?phone=+919883359713&text=${encodeURIComponent(message + ' ' + currentUrl)}`;
        window.open(whatsappLink, '_blank');
    };
    render() {
        return (
            <>
              <Helmet>
                    <title>Contact Us – Best Deal from Adorable Vacation LLP</title>
                    <meta name="description" content="We Offer the Best Travel Experiences. For Booking ☎ CALL Mr. SOUMALYA +91-98833-59713" />
                </Helmet>
                <MainHeader/>
                
                <Contact />

                <FooterDesktop />
                <div className="btn-whatsapp-pulse">
                    <a style={{ color: 'white' }} href="#" onClick={this.handleClick}>
                        <i className="fab fa-whatsapp"></i>
                    </a>
                </div>
            </>
        );
    }
}

export default ContactPage;
